import React, { useEffect, useState } from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import SearchIcon from "../../assets/icons/search.svg2";
import FilterIcon from "../../assets/icons/filter.svg2";
import { proxyAPI } from "../proxyAPI";
import { faCheck, faCross, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HelpButton from "../HelpContent/HelpButton";
import OriginatorIcon from "../../assets/icons/originator.svg2";
import { useLazyGetApiConnectionQuery } from "../store/slices/settingsSlice";
import MyPagination from "../Common/MyPagination";

function ProjectCard({
  campaign,
  selected,
  onSelect,
}: {
  campaign: any;
  selected: boolean;
  onSelect: (api: any) => void;
}) {
  return (
    <div key={campaign.ID} className={`my-3  ${selected ? "" : ""}`}>
      <button
        type="button"
        className={`btn h-100 w-100 bg-white p-3 text-start rounded-3 position-relative border border-2 ${
          selected ? "border-blue" : ""
        }`}
        onClick={() => {
          onSelect(campaign);
        }}
      >
        {selected ? (
          <FontAwesomeIcon
            icon={faCheck}
            className="position-absolute top-0 end-0 text-white bg-colored p-2"
            style={{
              borderBottomLeftRadius: 8,
            }}
          />
        ) : null}
        <div className="d-flex align-items-center">
          <div className=" w-100">
            <div>
              <h5 className="text-blue fw-bold">{campaign.Label}</h5>
            </div>
            <div className="d-flex justify-content-between align-items-start">
              <div className="text-small">
                <span className="text-bold"> Ref:</span>{" "}
                <span className="text-secondary"> {campaign.Uuid} </span>
              </div>
              <div>
                <span className="text-bold">Customer Ref: </span>{" "}
                <span className="text-secondary">{campaign.Reference}</span>{" "}
              </div>
            </div>
            <div className="text-small">
              <span className="text-bold">Description:</span>{" "}
              <span className="text-secondary">{campaign.Description}</span>
            </div>
            <div className="text-small">
              <span className="text-bold">Kind:</span>{" "}
              <span className="text-secondary">{campaign.Kind}</span>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}

export default function SelectApiConnection({
  selected,
  onSelect,
  apiKind = "third-party",
}: {
  selected: string | undefined;
  onSelect: (api: { ID: number; Uuid: string } | undefined) => void;
  apiKind?: "third-party" | "logic";
}) {
  const [show, setShow] = useState(!selected);
  const [selectedProject, setSelectedProject] = useState<any>();
  const [availableProjects, setAvailableProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setdebouncedSearch] = useState("");
  const [limit, setLimit] = useState(12);
  const [offset, setOffset] = useState(0);
  const [orderBy, setOrderBy] = useState("used-last");

  const [getApiConnection] = useLazyGetApiConnectionQuery();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setdebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  // get available projects
  useEffect(() => {
    (async () => {
      let sp;
      if (selected) {
        sp = await getApiConnection(selected);
        if (sp?.data) {
          setSelectedProject(sp.data);
        }
        setShow(false);
      } else {
        setShow(true);
        setSelectedProject(undefined);
      }
    })();
  }, [selected]);

  useEffect(() => {
    (async () => {
      const data = await proxyAPI({
        prefix: "logic/workflows/api",
        url: `/api-connections?search=${debouncedSearch}${
          selected ? `&ignoreUUID=${selected}` : ""
        }&kind=${apiKind}&orderBy=${orderBy}&limit=${limit}&offset=${offset}`,
      });
      if (data) {
        setAvailableProjects(data.connections);
        setTotal(data.total);
      }
    })();
  }, [debouncedSearch, offset, limit, selected]);

  return show ? (
    <div className="bg-purple-gradient-darker-reverse align-items-center p-4 px-5 mx-auto rounded-3 ">
      <div className="  d-flex justify-content-between mb-2">
        <div className="fw-bold fs-5">
          Select from existing {apiKind} APIs
          <HelpButton helpKey="select-api-connection" />
        </div>
        <div className="fw-bold">
          Api Selected:
          {selected ? (
            <FontAwesomeIcon
              icon={faCheck}
              className="text-success text-bold mx-2"
            />
          ) : (
            <FontAwesomeIcon
              icon={faX}
              className="text-danger text-bold mx-2"
            />
          )}
        </div>
      </div>
      <div>
        <div className="fw-bold mt-2">
          {/* <div className="">
            Selected API
            <div className="text-secondary my-2">
              {selectedProject ? "" : "No API selected"}
            </div>
            {selectedProject && (
              <ProjectCard
                campaign={selectedProject}
                selected={true}
                onSelect={() => {
                  setSelectedProject(undefined);
                  onSelect(undefined);
                }}
              />
            )}
          </div> */}
          <div className="">
            Available APIs
            <div className="d-flex bg-icon p-3 mt-2 rounded-3">
              <span className="fw-bold">Search for an API</span>
              <div className="flex-grow-1" />
              <div className="position-relative w-50">
                <input
                  className="form-control bg-purple rounded-3 "
                  style={{ height: 38, paddingRight: 40 }}
                  type="text"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
                <SearchIcon
                  width={30}
                  className="bg-purple-gradient position-absolute top-50 end-0 translate-middle rounded-3 p-2"
                  style={{ marginRight: -10 }}
                />
              </div>
            </div>
            {availableProjects?.length ? (
              <>
                <div style={{ maxHeight: 300, overflowY: "auto" }}>
                  {availableProjects.map((campaign: any) => (
                    <ProjectCard
                      key={campaign.Uuid}
                      campaign={campaign}
                      selected={false}
                      onSelect={onSelect}
                    />
                  ))}
                </div>
                <MyPagination
                  total={total}
                  onPaginate={(page: number, perPage: number) => {
                    setLimit(perPage);
                    setOffset(page * perPage);
                  }}
                />
              </>
            ) : (
              <div className="text-secondary my-3">No api found</div>
            )}
          </div>
        </div>
      </div>
      {/* {selectedProject && (
        <div className="d-flex justify-content-end mt-2 ">
          <button
            type="button"
            className="btn  btn-colored p-2 px-3 rounded-pill text-white fw-bold text-center"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </button>
        </div>
      )} */}
    </div>
  ) : (
    <>
      {selectedProject && (
        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-start">
            <h4 className="fw-bold">Selected API</h4>
            <div>
              <button
                type="button"
                className="btn  btn-colored p-1 px-2 rounded-pill text-white fw-bold text-center"
                onClick={() => {
                  setSelectedProject(undefined);
                  onSelect(undefined);
                  setShow(true);
                }}
              >
                REMOVE SELECTION
              </button>
            </div>
          </div>
          <ProjectCard
            campaign={selectedProject}
            selected={true}
            onSelect={() => {}}
          />
        </div>
      )}
    </>
  );
}
